import React from 'react'
import { Tooltip } from 'components'
import config from 'config'


const TypeInfo = ({ type }) => {
  const { title, info } = config.product.PRODUCT_TYPE[type];

  return ((title && info)
    ?
    <Tooltip
      id             = {type}
      containerClass = "txt-normal float-right"
      icon           = "194 margin-right-2"
      text           = {<span>什麼是{title}</span>}
      content        = {<div className="info-tooltip ua-tooltip ua-box default">{info}</div>}
    />
    :
    null
  );
}


export default TypeInfo
